export default __webpack_public_path__ + "static/media/compare.c1c2c69d.svg";